exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-el[data-v-1e1aa405]{width:1.5rem}", ""]);

// exports
